export default "__VITE_PUBLIC_ASSET__596c7ce7__"